import React from 'react'
import '../style/css/components/Breadcrumb.css'
import {Link} from "react-router-dom";

function Breadcrumb(props){
	return (
		<>
			<div className="row breadcrumb">
				<div className="col">
					<ul>
						<li>
							<Link to='/' ><i className='la la-home' /> Início</Link>
						</li>
						<li className='breadcrumb_separator'>
							<i className='la la-angle-right'/>
						</li>
						<li>
							{props.page}
						</li>
					</ul>
				</div>
			</div>
		</>
	);
}

export default Breadcrumb
